import { User, CampaignLimits, UserSettings } from './types/user';
import api from './';
import { AxiosResponse } from 'axios';
import { FeatureFlags } from './types/featureFlags';
import { SpellingsConfig } from './types/spellings';

const fetchCurrentUser = async () => {
  return await api.get<
    null,
    AxiosResponse<{ user: User; campaignLimits?: CampaignLimits | null; intercomJwt?: string }>
  >('/users/me');
};

const fetchFeatureFlags = async () => {
  return await api.get<null, AxiosResponse<FeatureFlags>>('/users/feature-flags');
};

const updateUserProfile = async (data: {
  firstName?: string;
  lastName?: string;
  email?: string;
}) => {
  return await api.post<typeof data, AxiosResponse<User>>('/users/me', data);
};

const fetchUserSettings = async () => {
  return await api.get<null, AxiosResponse<UserSettings>>('/users/settings');
};

const updateUserSettings = async (data: Partial<UserSettings>) => {
  return await api.put<typeof data, AxiosResponse<UserSettings>>('/users/settings', data);
};

const fetchGlobalSpellings = async () => {
  return await api.get<null, AxiosResponse<SpellingsConfig>>('/users/settings/spellings');
};

const updateGlobalSpellings = async (data: SpellingsConfig) => {
  return await api.put<typeof data, AxiosResponse<SpellingsConfig>>('/users/settings/spellings', data);
};

const UsersApi = {
  fetchCurrentUser,
  updateUserProfile,
  fetchFeatureFlags,
  fetchUserSettings,
  updateUserSettings,
  fetchGlobalSpellings,
  updateGlobalSpellings
};

export default UsersApi;
